(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("YYZone", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["YYZone"] = factory(require("vue"));
	else
		root["YYZone"] = factory(root["vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__62__) {
return 